import * as actionTypes from './userActionTypes';

const initialState = {
    loggedIn: false,   
    username: "",
    userid: "",
    isIntercommunales: false,
    isCity: false,
    customerId: '',
}

export default function user(state = initialState, action) {
    switch (action.type) {
        case (actionTypes.LOGIN):
            if (state.username !== action.username) {  
                let isInterCommunales = action.roles.some(x => x.name === "Intercommunales");

                return Object.assign({}, state, { 
                    loggedIn: true,                   
                    username: action.username,
                    userid: action.userid,
                    isInterCommunales: isInterCommunales,
                    customerId: action.customerId,
                });
            }
            return state;
        case (actionTypes.LOGOUT):
            if (state.loggedIn === true) {
                return Object.assign({}, state, { loggedIn: false, username: "", userid: "", isInterCommunales: false, customerId: ""});
            }
            return state;
        default:
            return state;
    }
}